/* ==========================================================================
   VITAL VIAL - Wishlist
   localStorage-backed, no app and no account required. Survives republishes,
   syncs across tabs, and degrades to a no-op if storage is unavailable.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'vv:wishlist:v1';
  var available = true;

  function read() {
    if (!available) return [];
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { available = false; return []; }
  }

  function write(list) {
    if (!available) return;
    try { localStorage.setItem(KEY, JSON.stringify(list)); }
    catch (e) { available = false; }
  }

  var Wishlist = {
    all: function () { return read(); },
    handles: function () { return read().map(function (i) { return i.handle; }); },
    has: function (handle) { return this.handles().indexOf(handle) > -1; },
    count: function () { return read().length; },

    add: function (item) {
      var list = read();
      if (list.some(function (i) { return i.handle === item.handle; })) return list;
      list.unshift({
        handle: item.handle,
        id: item.id || null,
        title: item.title || '',
        url: item.url || '',
        image: item.image || '',
        price: item.price || '',
        added: Date.now()
      });
      write(list);
      sync();
      return list;
    },

    remove: function (handle) {
      var list = read().filter(function (i) { return i.handle !== handle; });
      write(list);
      sync();
      return list;
    },

    toggle: function (item) {
      return this.has(item.handle) ? (this.remove(item.handle), false) : (this.add(item), true);
    },

    clear: function () { write([]); sync(); }
  };

  window.vvWishlist = Wishlist;

  /* ---------- Reflect state into the DOM -------------------------------- */
  function sync() {
    var handles = Wishlist.handles();
    var n = handles.length;

    document.querySelectorAll('[data-vv-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });

    document.querySelectorAll('[data-vv-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var saved = handles.indexOf(handle) > -1;
      btn.setAttribute('aria-pressed', String(saved));
      btn.classList.toggle('is-saved', saved);
      var label = btn.querySelector('[data-vv-wishlist-label]');
      if (label) {
        label.textContent = saved
          ? (btn.getAttribute('data-label-saved') || 'Saved')
          : (btn.getAttribute('data-label-add') || 'Save');
      }
    });

    if (window.vvBus) window.vvBus.emit('wishlist:changed', { count: n, handles: handles });
  }

  /* ---------- Click delegation ------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vv-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    Wishlist.toggle({
      handle: btn.getAttribute('data-handle'),
      id: btn.getAttribute('data-product-id'),
      title: btn.getAttribute('data-title'),
      url: btn.getAttribute('data-url'),
      image: btn.getAttribute('data-image'),
      price: btn.getAttribute('data-price')
    });

    if (!btn.classList.contains('is-saved')) return;
    // Small confirmation pulse
    btn.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }],
      { duration: 320, easing: 'cubic-bezier(.16,1,.3,1)' }
    );
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-vv-wishlist-remove]');
    if (!rm) return;
    e.preventDefault();
    var card = rm.closest('[data-vv-wishlist-card]');
    Wishlist.remove(rm.getAttribute('data-vv-wishlist-remove'));
    if (card) {
      card.style.transition = 'opacity .3s, transform .3s';
      card.style.opacity = '0';
      card.style.transform = 'scale(.96)';
      setTimeout(function () { card.remove(); renderPage(); }, 300);
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-vv-wishlist-clear]')) return;
    e.preventDefault();
    Wishlist.clear();
    renderPage();
  });

  /* ---------- Wishlist page rendering ----------------------------------- */
  function renderPage() {
    var mount = document.querySelector('[data-vv-wishlist-page]');
    if (!mount) return;

    var grid = mount.querySelector('[data-vv-wishlist-grid]');
    var empty = mount.querySelector('[data-vv-wishlist-empty]');
    var items = Wishlist.all();

    if (!items.length) {
      if (grid) { grid.innerHTML = ''; grid.hidden = true; }
      if (empty) empty.hidden = false;
      var actions = mount.querySelector('[data-vv-wishlist-actions]');
      if (actions) actions.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    if (grid) grid.hidden = false;
    var actionsEl = mount.querySelector('[data-vv-wishlist-actions]');
    if (actionsEl) actionsEl.hidden = false;

    var labelRemove = mount.getAttribute('data-label-remove') || 'Remove';
    var labelView = mount.getAttribute('data-label-view') || 'View product';

    grid.innerHTML = items.map(function (i) {
      return cardHTML(i, labelRemove, labelView);
    }).join('');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHTML(i, labelRemove, labelView) {
    return '<article class="vv-card" data-vv-wishlist-card>' +
      '<a class="vv-card__media-link" href="' + esc(i.url) + '">' +
        '<div class="vv-media" style="aspect-ratio:3/4;">' +
          (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) +
                     '" loading="lazy" decoding="async">' : '') +
        '</div>' +
      '</a>' +
      '<div class="vv-card__body">' +
        '<h3 class="vv-card__title"><a href="' + esc(i.url) + '">' + esc(i.title) + '</a></h3>' +
        (i.price ? '<p class="vv-card__price">' + esc(i.price) + '</p>' : '') +
        '<div class="vv-card__wishlist-actions">' +
          '<a class="vv-btn vv-btn--ghost vv-btn--sm" href="' + esc(i.url) + '">' + esc(labelView) + '</a>' +
          '<button class="vv-card__remove" type="button" data-vv-wishlist-remove="' + esc(i.handle) + '">' +
            esc(labelRemove) + '</button>' +
        '</div>' +
      '</div>' +
    '</article>';
  }

  /* ---------- Cross-tab sync -------------------------------------------- */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { sync(); renderPage(); }
  });

  function boot() { sync(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
